.cover {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: var(--radius-full);
}

.positive svg {
  color: var(--sentiment-positive);
}

.negative svg {
  color: var(--sentiment-negative);
}

.very_positive svg {
  color: var(--sentiment-very-positive);
}

.very_negative svg {
  color: var(--sentiment-very-negative);
}

.grid {
  overflow-x: auto;
}

.reach {
  min-width: 100px;
}

.clickableRow {
  cursor: pointer;
}

th {
  text-align: left;
}
